import React from "react"
import Modal from "react-bootstrap/Modal"
import Spinner from "react-bootstrap/Spinner"
import Button from "../common/Button.jsx"

/**
 * @param {{
 *   filename: string | null,
 *   isDeleting?: boolean,
 *   onCancel: () => void,
 *   onConfirm: () => void,
 * }} props
 */
export default function OrderFileDeleteModal({
    filename,
    isDeleting = false,
    onCancel,
    onConfirm,
}) {
    return (
        <Modal show={Boolean(filename)} onHide={() => { if (!isDeleting) onCancel() }} centered>
            <Modal.Header closeButton={!isDeleting}>
                <Modal.Title>Delete file?</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <span className="fw-semibold">{filename}</span> will be permanently deleted from the server.
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline" onClick={onCancel} disabled={isDeleting}>
                    Cancel
                </Button>
                <Button variant="danger" onClick={onConfirm} disabled={isDeleting}>
                    {isDeleting ? (
                        <span className="d-inline-flex align-items-center">
                            <Spinner animation="border" size="sm" className="me-2" />
                            Deleting...
                        </span>
                    ) : (
                        "Delete Permanently"
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
